/**
 * @param {*} value
 * @param {boolean} validationValue
 * @returns {boolean}
 */
function date ({ value, validationValue }) {
  if (!validationValue) return true
  if (!value?.year || !value?.month) return false

  const year = parseInt(value?.year, 10)
  const month = parseInt(value?.month, 10)

  return (
    year > 0 &&
    year.toString().length === 4 &&
    month > 0 &&
    month <= 12
  )
}

module.exports = { date }
